import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, TextField, Switch, FormControlLabel, IconButton, CircularProgress, MenuItem, Dialog, DialogContent, InputAdornment, Radio } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { closeModal, toggleLoading } from '../../../state/ModalSlice/ModalSlice';
import { useAppSelector } from '../../../state/state';
import { addDoc, collection, Timestamp, updateDoc } from 'firebase/firestore';
import { db, storage } from '../../../Config/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { OfferConstraint } from '../../Subscriptions/Pages/Offers/Offers';
import { RootState, useAppDispatch } from '../../../state/state';
import { } from '@mui/material';
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { GeoPoint } from "firebase/firestore";
import { getGeoHash } from '../utilityFunctions';
import SearchIcon from '@mui/icons-material/Search';
import discountPana from "../../../assets/GifsAndPlaceholders/Discount-pana.png"
import { getLatLong } from '../utilityFunctions';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { FLAVOR, SECRETS_ENV } from '../../../Config/firebase';
import { useBackend } from '../../../hooks/backend/useBackend';
import { selectBankAccounts, selectEffectiveUID } from '../../../state/UserStatesV2/userSliceV2';
const GEO_LOC_API = import.meta.env.VITE_GEOLOCATION_API_KEY || process.env.VITE_GEOLOCATION_API_KEY
const AddOfferModal: React.FC = () => {
    const isOpen = useSelector((state: RootState) => state.ModalSlice.AddOfferModalOpen);
    const providerId: string = useAppSelector(selectEffectiveUID)  
    const dispatch = useAppDispatch();
    const { axiosPostRequest } = useBackend("");

    const today = new Date();
    const thirtyDaysLater = new Date(today.getTime() + 30 * 24 * 60 * 60 * 1000);

    const [formData, setFormData] = useState({
        BuzzName: '',
        Description: '',
        OfferCode: '',
        isLive: true,
        offerConstraint: OfferConstraint.EVERYDAY,
        StartDate: today.toISOString().split('T')[0],
        EndDate: thirtyDaysLater.toISOString().split('T')[0],
        Price: "0",
        paymentProfileId: 0,
        geoLocation: { hash: "", latlang: new GeoPoint(0, 0) },
        placeName: "",
        placeAddress: "",

        TermsAndConditions: "Offer can be redeemed only once per mobile number"

    });
    const BankAccounts = useAppSelector(selectBankAccounts);
    const bankAccountOptions = BankAccounts.map(bankAccount => {
        return (

            bankAccount.iFSC.slice(0, 4) + " - " + bankAccount.accountNo)
    })
    const [errors, setErrors] = useState({
        BuzzName: false,
        Description: false,
        OfferCode: false,
        StartDate: false,
        EndDate: false,
        Price: false,
        location: false
    });

    const [image, setImage] = useState<File | null>(null);
    const [imagePreview, setImagePreview] = useState<string | null>(null);
    const [imageSizeExceeded, setImageSizeExceeded] = useState(false);
    const [location, setLocation] = useState<any>(null);
    const [geoPoint, setGeoPoint] = useState<GeoPoint | null>(null);
    const [paymentProfileID, setPaymentProfileID] = useState<number>(0);
    const [offerType, setOfferType] = useState<'free' | 'paid'>('free');


    const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading);
    useEffect(() => {
        if (location) {
           
            getLatLong(location.value.place_id).then((geometry: { lat: any, lng: any }) => {
                const geoPoint = new GeoPoint(geometry.lat, geometry.lng);

                setFormData(prev => ({
                    ...prev, geoLocation: { hash: geoPoint != null ? getGeoHash(geoPoint) || "" : "", latlang: geoPoint },
                    placeName: location.value.structured_formatting.main_text,
                    placeAddress: location.label
                }));
            })
        }
    }, [location])

    // Handle change functions
    const handleChangeBuzzName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, BuzzName: event.target.value }));
        setErrors(prev => ({ ...prev, BuzzName: false }));
    };


    const handleChangeDescription = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, Description: event.target.value }));
        setErrors(prev => ({ ...prev, Description: false }));
    };

    const handleChangeOfferCode = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, OfferCode: event.target.value }));
        setErrors(prev => ({ ...prev, OfferCode: false }));
    };

    const handleChangeIsLive = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, isLive: event.target.checked }));
    };


    const handleChangeOfferConstraint = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, offerConstraint: event.target.value as OfferConstraint }));
    };

    const handleChangeStartDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, StartDate: event.target.value }));
        setErrors(prev => ({ ...prev, StartDate: false }));
    };

    const handleChangeEndDate = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, EndDate: event.target.value }));
        setErrors(prev => ({ ...prev, EndDate: false }));
    };

    const handleChangeTermsAndConditions = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData(prev => ({ ...prev, TermsAndConditions: event.target.value }));
    };

    const handleChangePrice = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        // Function to handle only decimal and number inputs
        if (!value) {
            setFormData(prev => ({ ...prev, Price: "" }));
            return;
        }
        let decimalCount = 0;
        for (let i = 0; i < value.length; i++) {
            const char = value[i];
            if (char >= '0' && char <= '9') { /* empty */
            } else if (char === '.') {
                if (decimalCount === 0) {
                    decimalCount++;
                } else {
                    return;
                }
            } else {
                return;
            }
        }
        setFormData(prev => ({ ...prev, Price: event.target.value }));
        setErrors(prev => ({ ...prev, Price: false }));
    };

    const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        setImageSizeExceeded(false);
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                setImageSizeExceeded(true);
                return;
            }
            setImage(file);
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const validateForm = () => {
        let isValid = true;
        const newErrors = { ...errors };

        if (formData.BuzzName.trim() === '') {
            newErrors.BuzzName = true;
            isValid = false;
        }
        if (formData.Description.trim() === '') {
            newErrors.Description = true;
            isValid = false;
        }
        if (formData.OfferCode.trim() === '') {
            newErrors.OfferCode = true;
            isValid = false;
        }
        if (formData.StartDate === '') {
            newErrors.StartDate = true;
            isValid = false;
        }
        if (formData.EndDate === '') {
            newErrors.EndDate = true;
            isValid = false;
        } if (formData.Price.trim() === "") {
            newErrors.Price = true
            isValid = false
        }
        if (!location) {
            newErrors.location = true;
            isValid = false;
        }
        setErrors(newErrors);
        return isValid;
    };


    const handleChangePaymentProfile = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPaymentProfileID(Number(event.target.value));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validateForm()) return;
        dispatch(toggleLoading(true));
        try {
            let imageUrl = '';
            if (image) {
                const storageRef = ref(storage, `offers/${providerId}/${image.name}`);
                await uploadBytes(storageRef, image);
                imageUrl = await getDownloadURL(storageRef);
            } else {
                const defaultImageBlob = await fetch(discountPana).then(r => r.blob());
                const storageRef = ref(storage, `offers/${providerId}/default_discount_pana.png`);
                await uploadBytes(storageRef, defaultImageBlob);
                imageUrl = await getDownloadURL(storageRef);
            }

            const offerData = {
                ...formData,
                StartDate: Timestamp.fromDate(new Date(formData.StartDate)),
                EndDate: Timestamp.fromDate(new Date(formData.EndDate)),
                createdAt: Timestamp.now(),
                Price: Number(formData.Price),
                url: imageUrl,
                geoLocation: { ...formData.geoLocation, placeName: location == null ? "" : location?.value?.structured_formatting?.main_text, address: location == null ? "" : location?.label },
                paymentProfileId: paymentProfileID,

                placeName: location == null ? "" : location?.value?.structured_formatting?.main_text,
                placeAddress: location == null ? "" : location?.label,
                accountId: BankAccounts[paymentProfileID].razorpayAccountId
            };

            const offersCollectionRef = collection(db, 'ServiceProviders', providerId, 'Offers');
            const docRef = await addDoc(offersCollectionRef, offerData);
            const docId = docRef.id;

            const response: any = await axiosPostRequest(
                `${SECRETS_ENV.API_END_POINT}/api/shorten`,
                { 
                    longUrl: FLAVOR === "DEVELOPMENT" 
                        ? `https://plundrdev.hosaksham.com/details/${providerId}/offer/${docId}`
                        : `https://plundr.besaksham.com/details/${providerId}/offer/${docId}` 
                }
            );

            await updateDoc(docRef, { offerLink: response.data.shortUrl });
            handleClose();
        } catch (error) {
            console.error("Error adding offer:", error);
        } finally {
            dispatch(toggleLoading(false));
        }
    };

    const handleClose = () => {
        dispatch(closeModal('AddOfferModalOpen'));
        ResetStates();
    };

    function ResetStates() {
        setFormData({
            BuzzName: '',
            Description: '',
            OfferCode: '',
            isLive: true,
            offerConstraint: OfferConstraint.EVERYDAY,
            StartDate: today.toISOString().split('T')[0],
            EndDate: thirtyDaysLater.toISOString().split('T')[0],
            Price: "",
            paymentProfileId: 0,
            geoLocation: { hash: "", latlang: new GeoPoint(0, 0) },
            placeName: "",
            placeAddress: "",
            TermsAndConditions: ""
        });
        setImage(null);
        setImagePreview(null);
        setErrors({
            BuzzName: false,
            Description: false,
            OfferCode: false,
            StartDate: false,
            EndDate: false,
            Price: false,
            location: false
        });
        setLocation(null);
    }

    const handleOfferTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as 'free' | 'paid';
        setOfferType(value);
        if (value === 'free') {
            setFormData(prev => ({ ...prev, Price: "0" }));
        }
    };

    return (
        <Dialog
            sx={{
                padding: 0,
                '& .MuiPaper-root': {
                    borderRadius: '10px',
                },
            }}
            maxWidth="md"
            open={isOpen}
            PaperProps={{
                component: 'div',
            }}
        >
            <DialogContent sx={{ paddingX: "60px", paddingY: "50px" }} className={"bg-white"}>
                <div className={"w-[550px]"}>
                    <div className={"header pb-[20px]"}>
                        <p className={"text-cf_heading font-[600] "}>Add New Offer</p>
                    </div>

                    <div className={"absolute right-4 top-4"}>
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <div className={"pt-0"}>
                        <div className={""}>
                            <div className={""}>
                                <Box
                                    component={"div"}
                                    sx={{}}
                                >
                                    <div className="flex flex-col gap-4">
                                        <TextField
                                            label="Buzz Name*"
                                            value={formData.BuzzName}
                                            onChange={handleChangeBuzzName}
                                            error={errors.BuzzName}
                                            helperText={errors.BuzzName ? "Buzz Name is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        />
                                        <div className="flex items-center gap-4">
                                            <p className="text-sm text-gray-600 font-medium">Offer Type:</p>
                                            <div className="flex gap-4">
                                                <FormControlLabel
                                                    value="free"
                                                    control={
                                                        <Radio
                                                            checked={offerType === 'free'}
                                                            onChange={handleOfferTypeChange}
                                                            value="free"
                                                            size="small"
                                                        />
                                                    }
                                                    label={<span style={{ fontSize: '14px' }}>Free</span>}
                                                />
                                                <FormControlLabel
                                                    value="paid"
                                                    control={
                                                        <Radio
                                                            checked={offerType === 'paid'}
                                                            onChange={handleOfferTypeChange}
                                                            value="paid"
                                                            size="small"
                                                        />
                                                    }
                                                    label={<span style={{ fontSize: '14px' }}>Paid</span>}
                                                />
                                            </div>
                                        </div>
                                        {offerType === 'paid' && (
                                            <>
                                                <p className="text-xs text-gray-800 -mt-2 font-semibold">₹25 will be deducted per ticket as platform fee and rest will be credited to your account</p>
                                                <TextField
                                                    label="Price"
                                                    value={formData.Price}
                                                    onChange={handleChangePrice}
                                                    error={errors.Price}
                                                    helperText={errors.Price ? "Price is required" : ""}
                                                    fullWidth
                                                    size='small'
                                                    InputProps={{
                                                        startAdornment: <InputAdornment sx={{ fontSize: '14px' }}
                                                            position="start">₹</InputAdornment>,
                                                    }}
                                                    sx={{
                                                        '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                borderColor: 'grey',
                                                                borderRadius: '10px',
                                                            },
                                                            '&:hover fieldset': {
                                                                borderColor: 'grey',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: 'skyblue',
                                                            },
                                                            '& .MuiInputBase-input': {
                                                                fontSize: '14px',
                                                            },
                                                        },
                                                        fontWeight: 400,
                                                        width: '550px',
                                                    }}
                                                />
                                            </>
                                        )}
                                        <TextField
                                            label="Description*"
                                            value={formData.Description}
                                            onChange={handleChangeDescription}
                                            error={errors.Description}
                                            helperText={errors.Description ? "Description is required" : ""}
                                            fullWidth
                                            multiline
                                            rows={2}
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        />
                                        <TextField
                                            label="Offer Code*"
                                            value={formData.OfferCode}
                                            onChange={handleChangeOfferCode}
                                            error={errors.OfferCode}
                                            helperText={errors.OfferCode ? "Offer Code is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        />

                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={formData.isLive}
                                                    onChange={handleChangeIsLive}
                                                />
                                            }
                                            label="Is Live"
                                        />
                                        <TextField
                                            select
                                            label="Offer Constraint"
                                            value={formData.offerConstraint}
                                            onChange={handleChangeOfferConstraint}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        >
                                            {Object.values(OfferConstraint).map((constraint) => (
                                                <MenuItem key={constraint} value={constraint}>
                                                    {constraint}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField
                                            label="Start Date"
                                            type="date"
                                            value={formData.StartDate}
                                            onChange={handleChangeStartDate}
                                            error={errors.StartDate}
                                            helperText={errors.StartDate ? "Start Date is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <TextField
                                            label="End Date"
                                            type="date"
                                            value={formData.EndDate}
                                            onChange={handleChangeEndDate}
                                            error={errors.EndDate}
                                            helperText={errors.EndDate ? "End Date is required" : ""}
                                            fullWidth
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                        <div>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                sx={{
                                                    mb: 0,
                                                    borderRadius: '8px',
                                                    textTransform: 'none',
                                                    color: '#1D4ED8',
                                                    borderColor: '#1D4ED8',
                                                    '&:hover': {
                                                        backgroundColor: '#1D4ED8', color: "#FFFFFF"
                                                    },
                                                }}
                                            >
                                                <span className={"mr-1 flex justify-center items-center"}><AttachmentIcon fontSize='small' /> </span> Click here to upload Offers Display Image
                                                <input
                                                    type="file"
                                                    accept="image/jpeg, image/png"
                                                    hidden
                                                    onChange={handleImageChange}
                                                />
                                            </Button>
                                        </div>
                                        {imageSizeExceeded && (
                                            <p style={{ color: 'red' }}>Image size should not exceed 5MB</p>
                                        )}
                                        {imagePreview && (
                                            <Box sx={{ mb: 2, position: 'relative', width: 100, height: 100 }}>
                                                <img src={imagePreview} alt="Logo preview"
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                                                <IconButton
                                                    onClick={() => {
                                                        setImage(null);
                                                        setImagePreview(null);
                                                    }}
                                                    sx={{ position: 'absolute', top: 4, right: 4, bgcolor: 'background.paper' }}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </Box>
                                        )}
                                        <div className="flex flex-col gap-1">
                                            <div className="flex items-center gap-1">
                                                <p className="text-sm text-gray-600 font-medium">Location*</p>

                                            </div>
                                            <GooglePlacesAutocomplete
                                                apiKey={GEO_LOC_API || process.env.GEO_LOC_API}
                                                selectProps={{
                                                    placeholder: "Search location",
                                                    onChange: (value) => {
                                                        setLocation(value);
                                                        setErrors(prev => ({ ...prev, location: false }));
                                                    },
                                                    value: location,
                                                    components: {
                                                        DropdownIndicator: () => (
                                                            <div className="px-2">
                                                                <LocationOnIcon fontSize="small" style={{ color: errors.location ? '#EF4444' : '#6B7280' }} />
                                                            </div>
                                                        )
                                                    },
                                                    styles: {
                                                        input: (provided) => ({
                                                            ...provided, backgroundColor: 'transparent', // Fully opaque white background
                                                        }), option: (provided) => ({
                                                            ...provided, backgroundColor: 'transparent', // Fully opaque white background
                                                        }), singleValue: (provided) => ({
                                                            ...provided, backgroundColor: 'transparent', // Fully opaque white background
                                                        }), control: (provided) => ({
                                                            ...provided,
                                                            backgroundColor: 'transparent', // Fully opaque white background
                                                            borderColor: errors.location ? "#EF4444" : "gray",
                                                            boxShadow: 'none', // Remove the default shadow
                                                            '&:hover': {
                                                                borderColor: 'black', // Keep the border black on hover
                                                            },
                                                            '&:focus': {
                                                                borderColor: 'black', // Ensure the border is black when active
                                                            },
                                                            '&:active': {
                                                                borderColor: "black"
                                                            },
                                                            borderRadius: '10px',
                                                            fontSize: '14px'
                                                        }), menu: (provided) => ({
                                                            ...provided, backgroundColor: 'rgba(255, 255, 255, 1)', // Fully opaque white background
                                                            zIndex: 100, // Set z-index to 100
                                                        }), menuPortal: (provided) => ({
                                                            ...provided, zIndex: 100, // Ensure the menu portal has a z-index of 100
                                                        }),
                                                    },
                                                }}
                                            />
                                            {location && (
                                                <p className="text-sm text-gray-500 mt-1">
                                                    Selected: {location.label}
                                                </p>
                                            )}
                                            {errors.location && (
                                                <p className="text-red-500 text-xs font-semibold">Location is required</p>
                                            )}
                                        </div>
                                        <TextField
                                            size={"small"}
                                            id="Bank Account"
                                            select
                                            label="Bank account"
                                            value={paymentProfileID}
                                            onChange={handleChangePaymentProfile}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        >
                                            {/* Assuming you have a way to get bank account options */}
                                            {bankAccountOptions.length > 0 ? bankAccountOptions.map((option, index) => (
                                                <MenuItem key={index} value={index}>
                                                    {option}
                                                </MenuItem>
                                            )) : <MenuItem key="0" value={0}>No account Found</MenuItem>}
                                        </TextField>

                                        <TextField
                                            label="Terms and Conditions(Optional)"
                                            value={formData.TermsAndConditions}
                                            onChange={handleChangeTermsAndConditions}
                                            fullWidth
                                            multiline
                                            rows={2}
                                            size='small'
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: 'grey',
                                                        borderRadius: '10px',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: 'grey',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: 'skyblue',
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        fontSize: '14px',
                                                    },
                                                },
                                                fontWeight: 400,
                                                width: '550px',
                                            }}
                                        />

                                        <div className={"flex gap-2 pt-4"}>
                                            <button
                                                disabled={isLoading}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleClose();
                                                }}
                                                className={`w-full bg-cc_bg-tertiary border border-solid border-gray-500 p-1.5 rounded-lg ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={handleSubmit}
                                                disabled={isLoading}
                                                className={`w-full bg-cc_brand text-white p-1.5 rounded-lg border-gray-500 flex justify-center items-center ${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
                                            >
                                                {isLoading && <CircularProgress sx={{ color: "white" }} size={20} />}
                                                <p className={"ml-2"}>{isLoading ? "Loading" : "Add Offer"}</p>
                                            </button>
                                        </div>
                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default AddOfferModal;